var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlinePickups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 14C22.447 14 22 14.448 22 15C22 16.654 20.654 18 19 18H5C3.346 18 2 16.654 2 15V7C2 5.346 3.346 4 5 4H8C8.552 4 9 3.552 9 3C9 2.448 8.552 2 8 2H5C2.243 2 0 4.243 0 7V15C0 17.757 2.243 20 5 20H11V22H7C6.448 22 6 22.448 6 23C6 23.552 6.448 24 7 24H17C17.553 24 18 23.552 18 23C18 22.448 17.553 22 17 22H13V20H19C21.757 20 24 17.757 24 15C24 14.448 23.553 14 23 14Z",
    fill: "#0084D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H13.5C12.673 0 12 0.673 12 1.5V12H24V1.5C24 0.673 23.327 0 22.5 0ZM23 11H13V1.5C13 1.2245 13.2245 1 13.5 1H22.5C22.7755 1 23 1.2245 23 1.5V11ZM16 9H22V10H16V9ZM21.146 3.7675L22.728 5.3495L22.021 6.0565L21.0005 5.036V8H20.0005V5.036L19.0005 6.036L18.0005 5.036V8H17.0005V5.036L15.9545 6.082L15.2475 5.375L16.855 3.7675C17.211 3.4115 17.7905 3.4115 18.1465 3.7675L19.0005 4.6215L19.8545 3.7675C20.2105 3.4115 20.79 3.4115 21.146 3.7675Z",
    fill: "#0084D4",
    stroke: "#0084D4",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinePickups);
export default __webpack_public_path__ + "static/media/online-pickups.c720beb924cb7a9fa78a8e99fe5720d2.svg";
export { ForwardRef as ReactComponent };